import { BoxIcon } from '@givebutter/primitives/box-icon';
import { faCheck, faCircleInfo, faXmark } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as Dialog from 'components/dialog';
import { AddressReadable } from 'components/pages/campaign-settings/campaign-auction/AddressReadable';
import { DataHygieneAddressDataDetails } from 'types/domain';

interface WhatsThisDialogProps extends Dialog.DialogProps {}

const key = 'WhatsThisDialog';
const BAD_ADDRESS: DataHygieneAddressDataDetails = {
    address_1: '400 Broa',
    address_2: '',
    city: 'Seattle',
    state: 'Washing',
    zipcode: '98109',
    country: 'United States',
};
const GOOD_ADDRESS: DataHygieneAddressDataDetails = {
    address_1: '400 Broad St',
    address_2: '',
    city: 'Seattle',
    state: 'WA',
    zipcode: '98109',
    country: 'United States',
};
const WhatsThisDialog = (props: WhatsThisDialogProps) => {
    const { children, ...rest } = props;

    return (
        <Dialog.Root {...rest} key={key}>
            {children}
            <Dialog.Portal>
                <Dialog.Overlay />
                <Dialog.Content className="max-w-[360px] p-6 pb-8">
                    <div className="flex flex-col gap-4">
                        <BoxIcon size="lg">
                            <FontAwesomeIcon className="text-2xl" icon={faCircleInfo} />
                        </BoxIcon>
                        <div className="flex flex-col gap-1 text-sm text-gray-600">
                            <h2 className="text-lg font-semibold text-gray-900">
                                Automatic address formatting
                            </h2>
                            <p>
                                We routinely check and standardize addresses according to USPS
                                guidelines, such as spelling mistakes.
                            </p>
                        </div>
                        <div className="flex flex-col gap-3">
                            <h3 className="text-sm font-medium text-gray-700">Example</h3>
                            <div className="flex flex-col gap-10 sm:flex-row">
                                <div className="flex basis-1/2 flex-col gap-3 text-sm text-gray-600">
                                    <div className="inline-flex h-8 w-8 items-center justify-center rounded-full bg-red-100 text-base text-red-600">
                                        <FontAwesomeIcon icon={faXmark} />
                                    </div>

                                    <div className="flex flex-col gap-1.5">
                                        <h4 className="font-medium text-gray-700">
                                            Current Address
                                        </h4>
                                        <AddressReadable
                                            address={BAD_ADDRESS}
                                            className="text-gray-600"
                                        />
                                    </div>
                                </div>
                                <div className="flex basis-1/2 flex-col gap-3 text-sm text-gray-600">
                                    <div className="inline-flex h-8 w-8 items-center justify-center rounded-full bg-green-100 text-base text-green-600">
                                        <FontAwesomeIcon icon={faCheck} />
                                    </div>
                                    <div className="flex flex-col gap-1.5">
                                        <h4 className="font-medium text-gray-700">
                                            Updated Address
                                        </h4>
                                        <AddressReadable
                                            address={GOOD_ADDRESS}
                                            className="text-gray-600"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Dialog.Close />
                </Dialog.Content>
            </Dialog.Portal>
        </Dialog.Root>
    );
};

const WhatsThisDialogTrigger = Dialog.Trigger;
const Root = WhatsThisDialog;
const Trigger = WhatsThisDialogTrigger;

export {
    WhatsThisDialog,
    WhatsThisDialogTrigger,
    //
    Root,
    Trigger,
};
